import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { SubSink } from 'subsink';
import { User } from 'src/app/shared/models/user.model';
import { Router } from '@angular/router';
import { AuthenticationService } from 'src/app/shared/service/authentication.service';
import { UserService } from 'src/app/shared/service/user.service';
import { NoteComponent } from '../../../shared/components/note/note.component';
import { NbDialogRef, NbDialogService } from '@nebular/theme';
import { DateModel } from 'src/app/shared/models/date.model';
import { DateService } from 'src/app/shared/service/date.service';
import { Pagination } from '../../../shared/models/pagination.model';
import { LazyLoadEvent } from 'primeng/api';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss']
})
export class UsersComponent implements OnInit, OnDestroy {
  @ViewChild('KYCImageModal') KYCImageModal!: TemplateRef<any>;
  sub = new SubSink();
  tableLoading = true;
  settings: any;
  recordPerPage = 25;
  page: number = 1;
  token: string | undefined;
  pagination: Pagination<User> = new Pagination<User>();
  loading = false;
  selectedUser !: User;
  firstNameFilter!: string;
  lastNameFilter!: string;

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private userService: UserService,
    private dialogService: NbDialogService,
    private dateService: DateService
  ) {
    this.token = this.authenticationService.getToken();
  }

  Toast = Swal.mixin({
    toast: true,
    position: 'top',
    showConfirmButton: false,
    timer: 2000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer);
      toast.addEventListener('mouseleave', Swal.resumeTimer);
    }
  });

  checkScope(type: 'AND' | 'OR', ...scopes: string[]): boolean {
    return this.authenticationService.checkScope(type, ...scopes);
  }

  getUserList(event: LazyLoadEvent = {}) {
    this.tableLoading = true;
    if (event.first !== undefined && event.rows !== undefined) {
      this.page = event?.first / this.recordPerPage + 1;
    }
    const filter: any = {
      limit: this.recordPerPage,
      page: this.page
    };
    if (this.emailFilter) {
      filter.email = this.emailFilter;
    }
    if (this.firstNameFilter) {
      filter.first_name = this.firstNameFilter
    }
    if (this.lastNameFilter) {
      filter.last_name = this.lastNameFilter
    }
    if (this.phoneFilter) {
      filter.phone = this.phoneFilter;
    }
    if (this.nationalIDFilter) {
      filter.national_id = this.nationalIDFilter;
    }
    if (this.ibanFilter) {
      filter.iban = this.ibanFilter;
    }
    if (this.creditCardFilter) {
      filter.card = this.creditCardFilter;
    }
    if (this.kycStatusFilter) {
      filter.verification = this.kycStatusFilter;
    }

    this.userService.getUserListPagination(filter).subscribe((users: Pagination<User>) => {
      this.pagination = users;
      this.tableLoading = false;
    });
  }

  openKYCImagesModal(user: User) {
    if (user.identityVideo || user.identityImage || user.nationalCardImage) {
      this.selectedUser = user;
      this.dialogService.open(this.KYCImageModal);
    } else {
      this.Toast.fire({ icon: 'error', text: 'اطلاعات ثبت احوال کاربر موجود نیست.' });
    }
  }


  notification(user: User) {
    this.router.navigateByUrl('/dashboard/notification/' + user.id, {
      state: user
    });
  }

  note(user: User) {
    this.dialogService.open(NoteComponent, {
      hasBackdrop: true,
      dialogClass: 'note-modal-container',
      context: {
        userId: user.id
      }
    });
  }

  changePage(event: any): void {
    if (event.first !== undefined && event.rows !== undefined) {
      this.page = event?.first / this.recordPerPage + 1;
    }
    if (this.pagination.totalPages < this.page) {
      this.page = this.pagination.totalPages;
    }
    this.getUserList();
    this.tableLoading = true;
  }


  changeRecordPerPageLimit(recordPerPage: number): void {
    this.recordPerPage = recordPerPage;
    this.page = 1;
    this.getUserList();
  }

  private _downloadDialogRef?: NbDialogRef<any>;
  @ViewChild('downloadDialog') downloadDialog!: TemplateRef<any>;

  downloadStartDate!: string;
  downloadEndDate!: string;
  generatingExcel = false;
  phoneFilter!: string;
  emailFilter!: string;
  nameFilter!: string;
  creditCardFilter!: string;
  ibanFilter!: string;
  nationalIDFilter!: string;
  kycStatusFilter!: string;

  async generateUsersCSV() {
    this.generatingExcel = true;

    this.userService
      .generateKycReport(this.downloadStartDate, this.downloadEndDate)
      .subscribe((val: any) => {
        this.generatingExcel = false;

        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(val);
        link.download = `unverified_followup_${this.downloadStartDate}_${this.downloadEndDate}.xlsx`;
        link.click();
      });
  }

  closeDownloadDialog() {
    this._downloadDialogRef?.close();
  }

  openDownloaDialog() {
    this._downloadDialogRef = this.dialogService.open(this.downloadDialog);
  }

  setStart(event: DateModel): void {
    this.downloadStartDate = this.dateService.convertDateToStringGregorian(event) ?? '';
  }

  setEnd(event: DateModel): void {
    this.downloadEndDate = this.dateService.convertDateToStringGregorian(event) ?? '';
  }

  ngOnInit(): void {
    this.getUserList();
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

}
